import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
export function Guarantee() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-124" data-mp="20j8vgf84aabu">
      <div className="mx-auto max-w-2xl" data-id="element-125" data-mp="24mevv68jt7ae">
        <Reveal data-id="element-126" data-mp="24ldigv4288pi">
          <div className="rounded-3xl border border-ink-line bg-ink px-6 py-8 text-center sm:px-10 sm:py-10" data-id="element-127" data-mp="29doli6u3kama">
            <SectionBadge tone="dark" data-id="element-128" data-mp="2edjd6clp548e">Sin riesgo</SectionBadge>

            <span className="mx-auto mt-5 flex h-14 w-14 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-129" data-mp="2efdvdj5l2i8s">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-130" data-mp="2obgzgujzwqyd" />
            </span>

            <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-3xl" data-id="element-131" data-mp="2scstdc9wjycd">
              Tenés <span className="u-lime" data-id="element-132" data-mp="tx6b0n7bbyt4">7 días de garantía</span>
            </h2>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-snow sm:text-base" data-id="element-133" data-mp="tz95bjfi0e3n">
              Entrá, revisá el material y comprobá si realmente encaja con la forma en la que trabajás tus clases.
            </p>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-snow-muted" data-id="element-134" data-mp="3nuztnp38bd8v">
              Tu compra cuenta con una garantía de satisfacción de 7 días, de acuerdo con las condiciones informadas al
              momento de comprar.
            </p>
            <p className="mx-auto mt-3 max-w-md text-sm font-bold text-snow" data-id="element-135" data-mp="3dyd9l2iq8q7w">
              Así podés conocer el contenido con tranquilidad.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}